import { Injectable } from '@angular/core';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { CountryDetail } from '../../sharedcomponents/_common/countrylist/countryinformation';
import { state } from '../../sharedcomponents/_common/countrylist/state';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';

@Injectable()
export class CountryService {
  countrycollectionEx: any;
  // countryDetailsCollection: any;
  countrycollection = new Array<CountryDetail>();
  constructor(private utilserv: utilityService) {}

  getcountrylist(enevelop: any) {
    // this country collection coming from core api
    return this.utilserv.restPost(enevelop, AppSettings.ICEMasterService + '/GetCountryList');
  }

  // GetCountryDetailList(enevelop: any) {
  //   // this country collection coming from local DB
  //   return this.utilserv.restPost(enevelop, AppSettings.ICEMasterService + '/GetCountryDetailList');
  // }

  getPreferredCountrylist() {
    // this country collection is prefered country where user has done previous transactions
    return this.utilserv.soapPostwithoutAction(this.PreferredCountryEnvelope(), AppSettings.transactionService + '/GetOrder');
  }

  private PreferredCountryEnvelope() {
    let envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                    <s:Header>
                    <a:Action s:mustUnderstand="1">http://tempuri.org/ITransactionService/RecentCountriesUsedInMoneyTransfer</a:Action>
                    <a:MessageID>urn:uuid:5b9f2a7a-c696-44e7-bfe2-f7750f79d73c</a:MessageID>
                    <a:ReplyTo>
                    <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                    </a:ReplyTo>
                    </s:Header>
                    <s:Body>
                    <RequestBase xmlns="http://tempuri.org/">
                    <LanguageCode>en</LanguageCode>
                    <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap"
                    xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                    <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                    <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                    </Session>
                    </RequestBase>
                    </s:Body>
                    </s:Envelope>
                    `;
    return envelope;
  }

  getCountryListFromLocale() {
    // this country collection coming from core api
    if (this.countrycollection.length <= 0) {
      this.reInitialzeCountryList();
    }
    return this.countrycollection;
  }
  getCountryListFromLocaleEx() {
    // this country collection coming from core api
    this.reInitialzeCountryList();
    return this.countrycollectionEx;
  }

  getCountryDetailsList() {
    // this country collection coming from local db
    // this.reInitialzeCountryDetailList();
    // return this.countryDetailsCollection;
    return JSON.parse(`[{
      "CountryCode": "US",
      "CountryNames": [{
        "Language": "EN",
        "Name": "United States"
      }, {
        "Language": "ES",
        "Name": "Estados Unidos"
      }]
    }]`);
  }

  initialzeCountryList(response) {
    if (response.Countries != null && response.Countries != undefined) {
      localStorage.CountryCollection = JSON.stringify(response.Countries);
    }
    this.countrycollectionEx = localStorage.CountryCollection;
    //this.setCountryList(localStorage.CountryCollection);
  }

  reInitialzeCountryList() {
    const response = JSON.parse(localStorage.CountryCollection);
    this.countrycollectionEx = response;
    this.setCountryList(response);
  }

  // initialzeCountryDetailList(response) {
  //   if (response.Countries != null && response.Countries != undefined) {
  //     localStorage.countryDetailsCollection = JSON.stringify(response.Countries);
  //   }
  //   this.countryDetailsCollection = localStorage.countryDetailsCollection;
  // }
  // reInitialzeCountryDetailList() {
  //   const response = JSON.parse(localStorage.countryDetailsCollection);
  //   this.countryDetailsCollection = response;
  //   this.setCountryList(response);
  // }
  setCountryList(response) {
    response.forEach(element => {
      let stateCollection = new Array<state>();
      let countryinfo = new CountryDetail(
        element.CountryCode,
        element.CountryNames[0].Name,
        element.Currencies,
        element.DialingCode,
        null,
        element.DeliveryMethods,
        element.IsDestination,
        element.IsOrigin,
        element.PhoneNumberLength
      );

      element.states.forEach(stateelement => {
        let stateinfo = new state(stateelement.StateCode, stateelement.StateName, element.CountryCode, stateelement.Cities);
        stateCollection.push(stateinfo);
      });

      countryinfo.CountryState = stateCollection;

      this.countrycollection.push(countryinfo);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/commonservice/countrylist.service.ts